import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  cardForm: {
    height: 300,
  },
})
